import { Popover, Avatar } from "antd";
import { UserOutlined, MailOutlined, PhoneOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import React, {useEffect} from "react";

type LeadOwnerHoverProps = {
  name?: React.ReactNode;
  role?: string;
  email?: string;
  phone?: string;

  leadowner_name?: string;   // ✅ ADD
  company_name?: string;     // ✅ ADD
};

const LeadOwnerHoverCard = ({
  name,
  role,
  email,
  phone,
  leadowner_name,
  company_name,
}: LeadOwnerHoverProps) => {
  const navigate = useNavigate(); // ✅ REQUIRED

  useEffect(() => {
      const styleId = "animated-badge-keyframes";
      if (!document.getElementById(styleId)) {
        const styleSheet = document.createElement("style");
        styleSheet.id = styleId;
        styleSheet.innerText = `
          @keyframes shine {
            0% {
              transform: skewX(-20deg) translateX(-150%);
            }
            50% {
               transform: skewX(-20deg) translateX(150%);
            }
            100% {
              transform: skewX(-20deg) translateX(150%);
            }
          }
        `;
        document.head.appendChild(styleSheet);
      }
    }, []);
  const initial =
    typeof name === "string" ? name.charAt(0).toUpperCase() : "";

  // ✅ SAME AS LAST LEAD ACTIVITY
  const handleNavigate = () => {
    navigate(
      `/leads?owner=${encodeURIComponent(
        leadowner_name || ""
      )}&company=${encodeURIComponent(company_name || "")}`
    );
  };

  const content = (
    <div style={{ width: 240 }}>
      <div className="d-flex align-items-center mb-2">
        <Avatar
          shape="square"
          className="btn btn-primary"
          style={{ width: 36, height: 36, fontSize: 16, fontWeight: 600 }}
        >
          {initial || <UserOutlined />}
        </Avatar>

        <div className="ms-2">
          <div className="fw-semibold">{name || "Unassigned"}</div>
          <div className="text-muted small">{role || "-"}</div>
        </div>
      </div>

      {email && (
        <div className="d-flex align-items-center mb-1 small">
          <MailOutlined className="me-2 text-muted" />
          <span>{email}</span>
        </div>
      )}

      {phone && (
        <div className="d-flex align-items-center small mb-2">
          <PhoneOutlined className="me-2 text-muted" />
          <span>{phone}</span>
        </div>
      )}

      {/* ✅ BUTTON THAT NAVIGATES LIKE LAST LEAD ACTIVITY */}
      <button
        className="btn btn-sm btn-outline-primary w-100 mt-2"
        onClick={handleNavigate}
        style={{
                            position: "relative",
                            overflow: "hidden",
                          }}
      >
        <span style={{ position: "relative", zIndex: 2 }}>View Leads from this Owner</span>
        <span
                            style={{
                              position: "absolute",
                              top: 0,
                              left: 0,
                              width: "100%",
                              height: "100%",
                              background: "linear-gradient(to right, transparent 0%, rgba(255, 255, 255, 0.4) 50%, transparent 100%)",
                              transform: "skewX(-20deg) translateX(-150%)",
                              animation: "shine 3s infinite",
                            }}
                          />
      </button>
    </div>
  );

  return (
    <Popover content={content} placement="right" trigger="hover">
      <span style={{ cursor: "pointer" }}>
        {name || "Unassigned"}
      </span>
    </Popover>
  );
};

export default LeadOwnerHoverCard;
